import type { ReactNode } from 'react';
import { Tooltip } from 'antd';
import {
  CheckCircleFilled,
  CloseCircleFilled,
  LoadingOutlined,
  WarningFilled,
} from '@ant-design/icons';
import type { ProbeState } from './usePackageExistsProbe';

/**
 * 探测状态 → Input suffix 图标。idle 不显示(返回 null,与 antd 空 suffix 兼容)。
 * 图标一律 12px 缩进右侧,鼠标悬停能看 resolvedUrl / 错误消息。
 */
export function renderProbeSuffix(probe: ProbeState): ReactNode {
  if (probe.status === 'idle') return null;
  if (probe.status === 'checking') {
    return <LoadingOutlined style={{ color: '#8c8c8c' }} />;
  }
  if (probe.status === 'exists') {
    return (
      <Tooltip title={probe.resolvedUrl || '已在 BOS 上找到'}>
        <CheckCircleFilled style={{ color: '#52c41a' }} />
      </Tooltip>
    );
  }
  if (probe.status === 'missing') {
    return (
      <Tooltip title={probe.resolvedUrl || '未在 BOS 上找到'}>
        <CloseCircleFilled style={{ color: '#ff4d4f' }} />
      </Tooltip>
    );
  }
  // error: 探测本身失败(401 / 网络 / 模板未配), 不代表包真的不存在
  return (
    <Tooltip title={probe.message || '包状态探测失败'}>
      <WarningFilled style={{ color: '#faad14' }} />
    </Tooltip>
  );
}

/**
 * 探测状态 → Form.Item 的下方小字提示(extra)。仅 missing / error 显示,
 * idle / checking / exists 都不显示,避免 layout 抖动。
 */
export function renderProbeHint(probe: ProbeState): ReactNode {
  if (probe.status === 'missing') {
    return (
      <span style={{ fontSize: 12, color: '#ff4d4f' }}>
        未在百度云 BOS 上找到该算法包,请确认版本号是否正确
      </span>
    );
  }
  if (probe.status === 'error') {
    return (
      <span style={{ fontSize: 12, color: '#8c8c8c' }}>
        算法包状态探测失败({probe.message || '未知错误'}),不影响提交
      </span>
    );
  }
  return null;
}
